/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2023, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { AeroModule } from 'src/aero/aero.module';
import { SubmitAssignmentButtonComponent } from './submit-assignment-button/submit-assignment-button.component';

@NgModule({
  declarations: [
    SubmitAssignmentButtonComponent,
  ],
  exports: [
    SubmitAssignmentButtonComponent,
  ],
  imports: [
    CommonModule,
    AeroModule,
    TooltipModule,
    TranslocoModule,
  ],
})
export class SubmitAssignmentModule { }
